import { Collapse, Box } from '@mui/material';
import { TransitionGroup } from 'react-transition-group';

import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { List } from 'shared/components/List';
import { Loader } from 'shared/components/Loader';

import { ChatTopic } from './components/ChatTopic';
import { ChatTopicsWrapper } from './components/ChatTopicsWrapper';
import { Menu } from './components/Menu';
import { Skeleton } from './components/Skeleton';
import { Wrapper } from './components/Wrapper';
import { CONTENT_TOP_ELEMENT_ID } from './constants';
import { useGroupedTopics, useLoadMore } from './hooks';

export const Content = () => {
  const groupedTopics = useGroupedTopics();
  const { isLoadingChatTopics, isLoadingMore } = useParentHelperContext();
  const { capturingIntersectionElement } = useLoadMore();

  if (isLoadingChatTopics) {
    return <Skeleton />;
  }

  return (
    <Wrapper>
      <Box id={CONTENT_TOP_ELEMENT_ID} />
      {groupedTopics.map(({ title, topics, titleKey }) => (
        <ChatTopicsWrapper key={title} title={title} titleKey={titleKey}>
          <List disablePadding>
            <TransitionGroup>
              {topics.map(({ topic, chatId, lastUpdatedDate }, index) => (
                <Collapse key={chatId}>
                  <ChatTopic
                    key={chatId}
                    topic={topic}
                    chatId={chatId}
                    lastUpdatedDate={lastUpdatedDate}
                    loadMoreRef={
                      index === topics.length - 1
                        ? capturingIntersectionElement
                        : undefined
                    }
                  />
                </Collapse>
              ))}
            </TransitionGroup>
          </List>
        </ChatTopicsWrapper>
      ))}
      {isLoadingMore && (
        <Box sx={{ mt: 1 }}>
          <Loader size="sm" />
        </Box>
      )}
      <Menu />
    </Wrapper>
  );
};
